import { EngineRenderers } from '@websky/core/src/renderProps';

import { overrideIcons } from './components/Icons/OverrideIcons';
import BaggageDialogHeader from './components/BaggageDialogHeader/BaggageDialogHeader';
import OverriddenCheckoutForm from './components/CheckoutForm/CheckoutForm';
import OrderInsuranceBlockSlotUpsale from '@websky/core/src/Checkout/components/Checkout/OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';
import LoyaltyV2 from '@websky/core/src/CheckoutAdditionalService/components/LoyaltyV2/LoyaltyV2';
import PriceDetailsExtendedVariant from '@websky/core/src/LEO/Refund/PriceDetails/components/PriceDetailsExtendedVariant/PriceDetailsExtendedVariant';
import CreateRequest from './components/Exchange/CreateRequest';
import RequestForm from './components/Refund/RequestForm';
import { SearchFormDatepickerCompactMoney } from './components/SearchForm/SearchFormDatepickerCompactMoney/SearchFormDatepickerCompactMoney';
import { PriceDetailsShortVariant } from '@websky/core/src/__fsd__/entities/order';

export const renders: EngineRenderers = {
	...overrideIcons,
	BaggageDialogHeader: BaggageDialogHeader,
	CheckoutForm: OverriddenCheckoutForm,
	CheckoutInsurance: OrderInsuranceBlockSlotUpsale,
	CheckoutLoyalty: LoyaltyV2,
	PriceDetails: PriceDetailsExtendedVariant,
	renderExchangeCreateRequest: CreateRequest,
	renderRequestForm: RequestForm,
	SearchFormDatepickerCompactMoney,
	RefundPrices: PriceDetailsShortVariant
};
